//
// Message store
//

import messages from 'resources/messages.json';

// ------------------------------------
// Message types
// ------------------------------------

export const INFO = 'info';
export const SUCCESS = 'success';
export const ERROR = 'error';

// ------------------------------------
// Action definitions
// ------------------------------------

export const SHOW_MESSAGE = 'MESSAGE/SHOW';
export const HIDE_MESSAGE = 'MESSAGE/HIDE';

// ------------------------------------
// Action creators
// ------------------------------------

const getMessage = path => {
  return path.split('.').reduce((object, property) => {
    return object ? object[property] : undefined
  }, messages);
}

export const showMessage = (path, type = INFO) => dispatch => {
  const content = getMessage(path);
  dispatch({
    type: SHOW_MESSAGE,
    message: {
      content,
      type
    }
  });
};

export const showInfo = path => dispatch => {
  dispatch(showMessage(path, INFO));
};

export const showSuccess = path => dispatch => {
  dispatch(showMessage(path, SUCCESS));
};

export const showError = path => dispatch => {
  dispatch(showMessage(path, ERROR));
};

export const hideMessage = () => ({
  type: HIDE_MESSAGE
});

// ------------------------------------
// Initial state
// ------------------------------------

const initialState = {
  content: null,
  type: null,
  timestamp: null
};

// ------------------------------------
// Reducer
// ------------------------------------

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_MESSAGE:
      const { content, type } = action.message;
      return {
        content,
        type,
        timestamp: Date.now() // Ensure state update on equal messages.
      };

    case HIDE_MESSAGE:
      return initialState;

    default:
      return state
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/messages.js